<template>
  <div class="item">
    <div class="item-header">
      <div style="overflow: hidden; margin-bottom: 16px;">
        <div class="item-img" :style="{ backgroundImage: `url(/${$staticPath}/${news.src})`}">
      </div>
      </div>
      <h1>{{news.header}}</h1>
    </div>
    <div class="item-tag">
      <p>{{news.type}}</p>
      <p>{{news.time}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['news']
}
</script>

<style scoped>
  @import url('../../../static/css/news-style/newsItem.css');
</style>



// WEBPACK FOOTER //
// src/components/News/NewsItem.vue